// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
export const isTotalWeightValid = (weightStrings: string[]) => {
  if (weightStrings.length === 0) {
    return true;
  }

  const totalWeight = weightStrings.reduce((sum, weightStr) => {
    const weightNum = parseFloat(weightStr);
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(weightNum)) {
      return sum + weightNum;
    }
    return sum;
  }, 0);

  return totalWeight === 1;
};
